const MilkType = [
    {id: 0, name: "Regular", code: "", style: ""},
    {id: 6, name: "Pasture Access", code: "PA", style: "pa"},
    {id: 7, name: "Organic", code: "ORG", style: "org"},
    {id: 8, name: "Kosher", code: "KO", style: "ko"}
]
export default MilkType;